import decode from 'jwt-decode';
import {globales} from './global'
const jwt = require('jsonwebtoken');

let global;

export default class AuthService_primero {
    // Initializing important variables
    constructor(domain) {
        this.domain = domain || globales.ip // API server domain
        this.fetch = this.fetch.bind(this) // React binding stuff
        this.login = this.login.bind(this)
        this.getProfile = this.getProfile.bind(this)
    }
    login(username, password) { // Get a token from api server using the fetch api
        //console.log('obtener_sucursal');
        return this.fetch(`${this.domain}/obtener_sucursal`, {
            method: 'POST',
            body: JSON.stringify({
                username
            })
        }).then(res => {
            if( res.mensaje !== "Authentication_Failed" ){
                localStorage.setItem('usuario', username)
                return res;
            }
            return Promise.resolve(res);
        })
    }

    ver() {
        const _this = this
        return new Promise(function (resolve, reject) {  
            const token = _this.getToken()
           
             var bol;
             jwt.verify(token, 'abc+123', function(err, decoded) {
                 if(err!==null)
                 {
                    bol= false;
                 }
                 else
                  {
                    bol= true;
                  }
                });
                ;
            resolve(global=bol);                          
      });
    }
    loggedIn() { // Checks if there is a saved token and it's still valid
        const token = this.getToken() // GEtting token from localstorage  
         this.ver().then(function (){
        })
          if(token!==null &&  global===true )
             {
                 return global;
             }
             else{
                 return global;
             } 
    }

    getToken() { // Retrieves the user token from localStorage
        return localStorage.getItem('id_token')
    }
    logout() {// Clear user token and profile data from localStorage
        localStorage.removeItem('id_token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('estado_menu');  
    }
    getProfile() { // Using jwt-decode npm package to decode the token
        return decode(this.getToken());
    }
    fetch(url, options){// performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        // Setting Authorization header
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }
        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => response.json())
    }
    _checkStatus(response) { // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
            return response
        } else {
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }
}